module.exports = __webpack_public_path__ + "media/images/load-bf1aa996.gif";